import type { QualificationId, LenderData } from '@makemydeal/dr-shared-types';

export type DeskingState = {
    lastFailureAction?: string | null;
    showTotalTaxRateSupersedeAlert?: boolean | null;
    psErrorDetails: {
        lookupKey: string | null;
        actionForPayment: string;
        originalPSError: string;
        psErrorMessagePath: string;
    };
    hasForceReloadOnWSEventTriggered: boolean;
    forceReloadSource?: string;
    forceReloadMessage?: string;
    aiVehicleRecommendations?: AIVehicleRecommendation[];
    aiVehicleRecommendationsLoading?: boolean;
    qualificationIds: Array<QualificationId>;
    lenderProbabilities?: LenderData[];
    lenderProbabilitiesLoading?: boolean;
    shouldShowAIRefreshButton?: boolean;
    lenderCreditSource?: LenderCreditSource;
    softPullCreditScore?: number;
    /** Aggregate approval likelihood from the lender-probability response root (drives the card). */
    lenderAffordabilityLevel?: 'High' | 'Limited';
    /** Aggregate "starting at" APR from the lender-probability response root (drives the card). */
    lenderPredictedRate?: string;
};

export type LenderCreditSource = 'softpull' | 'selfReported' | 'dealerDefault';
export const LENDER_CREDIT_SOURCE_SOFT_PULL: LenderCreditSource = 'softpull';

export type AIVehicleRecommendation = {
    vehicle: {
        year: number;
        make: string;
        model: string;
        trim: string;
        exteriorColor: string;
        mileage: number;
        imageUrl: string;
        listedPrice: number;
        inventoryDate?: string;
        inventoryStatus?: string;
    };
    payment: {
        monthlyPayment: number;
        downPayment: number;
        apr: number;
        sellRate?: number;
        vehicleProfit?: number;
        approvalOdds?: number;
    };
    affordability: {
        level: 'HIGH' | 'LIMITED';
        lenderProbability: {
            lender: string;
            lenderId?: string;
        };
        dataSource: LenderCreditSource;
    };
};
